import {h, Fragment} from "preact"
import { useAppStateSelector, useSelectedFiltersCount, pick } from "@nosto/preact";
import { useGrid } from "./GridContext";
import Icon from "./elements/Icon";
import { toggleButtonId } from "./Sidebar";

function ToggleMobileSidebarButton({ selectedFiltersCount, className }) {
    return (
        <label
            htmlFor={toggleButtonId}
            className="mobile-filter-btn flex items-center gap-2 uppercase color-text border-b border-solid color-border-dark lg:hidden"
        >
            <span>Filter</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 16 15" fill="none">
                <path d="M2.29639 7.50094V0.982422M13.7038 14.0195V11.575M2.29639 14.0195V10.7602M13.7038 8.31576V0.982422M8.00009 3.42687V0.982422M8.00009 14.0195V6.68613" stroke="#191919" stroke-width="1.25" stroke-linecap="round"/>
                <path d="M2.29638 10.7593C3.1964 10.7593 3.92601 10.0296 3.92601 9.12963C3.92601 8.22961 3.1964 7.5 2.29638 7.5C1.39636 7.5 0.666748 8.22961 0.666748 9.12963C0.666748 10.0296 1.39636 10.7593 2.29638 10.7593Z" stroke="#191919" stroke-width="1.25" stroke-linecap="round"/>
                <path d="M7.99999 6.68699C8.90001 6.68699 9.62962 5.95738 9.62962 5.05736C9.62962 4.15734 8.90001 3.42773 7.99999 3.42773C7.09997 3.42773 6.37036 4.15734 6.37036 5.05736C6.37036 5.95738 7.09997 6.68699 7.99999 6.68699Z" stroke="#191919" stroke-width="1.25" stroke-linecap="round"/>
                <path d="M13.7038 11.5757C14.6039 11.5757 15.3335 10.8461 15.3335 9.94604C15.3335 9.04602 14.6039 8.31641 13.7038 8.31641C12.8038 8.31641 12.0742 9.04602 12.0742 9.94604C12.0742 10.8461 12.8038 11.5757 13.7038 11.5757Z" stroke="#191919" stroke-width="1.25" stroke-linecap="round"/>
            </svg>
        </label>
    );
}

export default function Toolbar() {
    const { loading, query, response, pageType } = useAppStateSelector(state =>
        pick(state, "loading", "query", "response", "pageType")
    );
    const selectedFiltersCount = useSelectedFiltersCount();
    const { gridOption, setGridOption, showOnModel, setShowOnModel } = useGrid();

    const handleGridChange = event => {
        setGridOption(event.target.value);
    };

    const handleModelImage = event => {
        const isChecked = event.target.checked;
        setShowOnModel(isChecked); 
    };

    const docCount = response.products?.total ?? 0;
    const totalSummary = `${docCount} products`;

    return (
        <div
            className="ns-header-controls ns-d-flex items-center ns-d-none ns-d-md-flex ns-flex-wrap align-center ns-justify-content-between"
            style={loading ? { opacity: 0.3, justifyContent: "end" } : {}}
        >
            <ToggleMobileSidebarButton selectedFiltersCount={selectedFiltersCount} />

            {!loading && (
                <span
                    className="total-results flex items-center gap-1 uppercase font-medium text-[14px] tracking-[.7px] color-text pr-8"
                    data-nosto-element="totalResults"
                >
                    {totalSummary}
                </span>
            )}
            <div className="ns-d-flex ns-flex-wrap ns-justify-content-between ns-d-md-block nos-w-100">
                <div className="ns-radio-group view-group">
                    <span className="ns-radio-label ns-mr-2">VIEW:</span>
                  {["1", "2", "3"].map((option, idx) => {
                        const labelTexts = ["3", "4", "6"];
                        return (
                            <>
                                <input
                                    type="radio"
                                    value={option}
                                    checked={gridOption === option}
                                    onChange={handleGridChange}
                                    id={option}
                                    className="ns-radio-input ns-mr-1"
                                />
                                <label htmlFor={option} key={option} className={`grid-template-option-${option}`}>
                                    <span>{labelTexts[idx]}</span>
                                </label>
                            </>
                        );
                    })}
                </div>
            </div>
            <label htmlFor="model" className="toggle-switch">
                <input
                    type="checkbox"
                    name="model"
                    id="model"
                    class="sr-only"
                    checked={showOnModel} // Use context state
                    onChange={handleModelImage}
                />
                Show on model
                <span className="slider" />
            </label>
        </div>
    );
}